
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useOwnerData = () => {
  return useQuery({
    queryKey: ["ownerData"],
    queryFn: async () => {
      try {
        // Vérifier d'abord si nous avons une session active
        const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) {
          console.error("Session error:", sessionError);
          throw new Error("Erreur de session");
        }

        if (!sessionData.session) {
          console.log("No active session");
          return null;
        }

        const { data: { user }, error: userError } = await supabase.auth.getUser();
        if (userError) {
          console.error("User error:", userError);
          throw userError;
        }
        
        if (!user) {
          console.error("No user found");
          return null;
        }

        // If user is an owner_user, use their reference_owner_id instead
        const ownerId = user.user_metadata?.reference_owner_id || user.id;

        const { data: ownerDataResult, error: ownerError } = await supabase
          .from("owner_data")
          .select(`
            *,
            business_types!owner_data_business_type_id_fkey (
              id, 
              name, 
              description
            )
          `)
          .eq("owner_id", ownerId)
          .maybeSingle();

        if (ownerError) {
          console.error("Error fetching owner data:", ownerError);
          throw ownerError;
        }

        if (!ownerDataResult) {
          console.log("No owner data found");
          return null;
        }

        return ownerDataResult;
      } catch (error) {
        console.error("Error in owner data query:", error);
        throw error;
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
